import React, { useCallback, useEffect, useState } from "react";
import api, { BASE_URL } from "../../Utils/api";
import {
  Badge,
  Button,
  Card,
  Col,
  Form,
  Modal,
  Pagination,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";


function formatarDataHora(valor) {
  if (!valor) return "—";
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return String(valor);
  return d.toLocaleString("pt-BR");
}

function LogsGodMode() {
  const token = localStorage.getItem("authToken");
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [pagina, setPagina] = useState(1);
  const [limite] = useState(30);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [detalhe, setDetalhe] = useState(null);
  const [loadingDetalhe, setLoadingDetalhe] = useState(false);

  const [filtroTipo, setFiltroTipo] = useState("Erro");
  const [filtroEntidade, setFiltroEntidade] = useState("");
  const [filtroUsuario, setFiltroUsuario] = useState("");
  const [filtroDocumento, setFiltroDocumento] = useState("");
  const [filtroBusca, setFiltroBusca] = useState("");
  const [filtroDataInicio, setFiltroDataInicio] = useState("");
  const [filtroDataFim, setFiltroDataFim] = useState("");

  const totalPaginas = limite > 0 ? Math.ceil(total / limite) : 0;

  const carregarLogs = useCallback(async () => {
    if (!token) {
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const params = { pagina, limite };
      if (filtroTipo) params.tipo = filtroTipo;
      if (filtroEntidade) params.id_entidade = filtroEntidade;
      if (filtroUsuario) params.id_usuario = filtroUsuario;
      if (filtroDocumento) params.id_documento = filtroDocumento;
      if (filtroBusca) params.busca = filtroBusca;
      if (filtroDataInicio) params.data_inicio = filtroDataInicio;
      if (filtroDataFim) params.data_fim = filtroDataFim;

      const { data } = await api.get(`${BASE_URL}/api/godmode/logs`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      });
      setLogs(Array.isArray(data?.data) ? data.data : []);
      setTotal(data?.paginacao?.total ?? 0);
    } catch (err) {
      console.error("Erro ao carregar logs:", err);
      setError(err.response?.data?.message || "Erro ao carregar logs de erro.");
      setLogs([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [
    token,
    pagina,
    limite,
    filtroTipo,
    filtroEntidade,
    filtroUsuario,
    filtroDocumento,
    filtroBusca,
    filtroDataInicio,
    filtroDataFim,
  ]);

  useEffect(() => {
    carregarLogs();
  }, [carregarLogs]);

  const aplicarFiltros = (e) => {
    e.preventDefault();
    setPagina(1);
    carregarLogs();
  };

  const abrirDetalhe = async (id) => {
    setLoadingDetalhe(true);
    setDetalhe(null);
    try {
      const { data } = await api.get(`${BASE_URL}/api/godmode/logs/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDetalhe(data?.data || null);
    } catch (err) {
      console.error("Erro ao carregar detalhe do log:", err);
      setDetalhe({ erro: err.response?.data?.message || "Erro ao carregar detalhe." });
    } finally {
      setLoadingDetalhe(false);
    }
  };

  return (
    <div>
      <Card className="mb-3">
        <Card.Body>
          <Form onSubmit={aplicarFiltros}>
            <Row className="g-2 align-items-end">
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">Tipo</Form.Label>
                <Form.Select size="sm" value={filtroTipo} onChange={(e) => setFiltroTipo(e.target.value)}>
                  <option value="">Todos</option>
                  <option value="Erro">Erro</option>
                </Form.Select>
              </Col>
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">ID entidade</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  min="1"
                  value={filtroEntidade}
                  onChange={(e) => setFiltroEntidade(e.target.value)}
                />
              </Col>
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">ID usuário</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  min="1"
                  value={filtroUsuario}
                  onChange={(e) => setFiltroUsuario(e.target.value)}
                />
              </Col>
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">ID documento</Form.Label>
                <Form.Control
                  size="sm"
                  type="number"
                  min="1"
                  value={filtroDocumento}
                  onChange={(e) => setFiltroDocumento(e.target.value)}
                />
              </Col>
              <Col xs={12} md={4}>
                <Form.Label className="small mb-1">Busca (descrição, origem, código)</Form.Label>
                <Form.Control
                  size="sm"
                  value={filtroBusca}
                  onChange={(e) => setFiltroBusca(e.target.value)}
                  placeholder="Texto livre..."
                />
              </Col>
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">Data início</Form.Label>
                <Form.Control
                  size="sm"
                  type="date"
                  value={filtroDataInicio}
                  onChange={(e) => setFiltroDataInicio(e.target.value)}
                />
              </Col>
              <Col xs={6} md={2}>
                <Form.Label className="small mb-1">Data fim</Form.Label>
                <Form.Control
                  size="sm"
                  type="date"
                  value={filtroDataFim}
                  onChange={(e) => setFiltroDataFim(e.target.value)}
                />
              </Col>
              <Col xs="auto">
                <Button type="submit" variant="primary" size="sm">
                  Filtrar
                </Button>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>

      {error && (
        <Card className="mb-3 border-danger">
          <Card.Body className="text-danger">{error}</Card.Body>
        </Card>
      )}

      {loading ? (
        <div className="d-flex justify-content-center py-5">
          <Spinner animation="border" />
        </div>
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <small className="text-muted">
              {total} registro(s) — página {pagina} de {totalPaginas || 1}
            </small>
            <Button variant="outline-secondary" size="sm" onClick={carregarLogs}>
              Atualizar
            </Button>
          </div>

          <Card>
            <div className="table-responsive">
              <Table hover size="sm" className="mb-0">
                <thead>
                  <tr>
                    <th>Data/hora</th>
                    <th>Tipo</th>
                    <th>HTTP</th>
                    <th>Entidade</th>
                    <th>Usuário</th>
                    <th>Documento</th>
                    <th>Origem</th>
                    <th>Descrição</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {logs.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="text-center text-muted py-4">
                        Nenhum log encontrado.
                      </td>
                    </tr>
                  ) : (
                    logs.map((log) => (
                      <tr key={log.id}>
                        <td className="text-nowrap">{formatarDataHora(log.data_hora)}</td>
                        <td>
                          <Badge bg={log.tipo === "Erro" ? "danger" : "secondary"}>{log.tipo || "—"}</Badge>
                        </td>
                        <td>{log.status_http ?? "—"}</td>
                        <td>{log.id_entidade ?? "—"}</td>
                        <td>{log.id_usuario ?? "—"}</td>
                        <td>{log.id_documento ?? "—"}</td>
                        <td className="text-truncate" style={{ maxWidth: 180 }} title={log.origem}>
                          {log.origem || "—"}
                        </td>
                        <td className="text-truncate" style={{ maxWidth: 260 }} title={log.descricao}>
                          {log.descricao || "—"}
                        </td>
                        <td>
                          <Button variant="link" size="sm" className="p-0" onClick={() => abrirDetalhe(log.id)}>
                            Detalhe
                          </Button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </Table>
            </div>
          </Card>

          {totalPaginas > 1 && (
            <Pagination className="justify-content-center mt-3">
              <Pagination.Prev disabled={pagina <= 1} onClick={() => setPagina((p) => Math.max(1, p - 1))} />
              <Pagination.Item active>{pagina}</Pagination.Item>
              <Pagination.Next
                disabled={pagina >= totalPaginas}
                onClick={() => setPagina((p) => Math.min(totalPaginas, p + 1))}
              />
            </Pagination>
          )}
        </>
      )}

      <Modal show={detalhe != null || loadingDetalhe} onHide={() => setDetalhe(null)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Detalhe do log #{detalhe?.id ?? "…"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {loadingDetalhe ? (
            <div className="text-center py-4">
              <Spinner animation="border" size="sm" />
            </div>
          ) : detalhe?.erro ? (
            <p className="text-danger mb-0">{detalhe.erro}</p>
          ) : detalhe ? (
            <>
              <p className="mb-1">
                <strong>Data:</strong> {formatarDataHora(detalhe.data_hora)}
              </p>
              <p className="mb-1">
                <strong>Tipo:</strong> {detalhe.tipo} — <strong>HTTP:</strong> {detalhe.status_http ?? "—"}
              </p>
              <p className="mb-1">
                <strong>Rastreio:</strong> entidade {detalhe.id_entidade ?? "—"} · usuário{" "}
                {detalhe.id_usuario ?? "—"} · documento {detalhe.id_documento ?? "—"}
                {detalhe.id_referencia
                  ? ` · ref ${detalhe.tipo_referencia || "?"} #${detalhe.id_referencia}`
                  : ""}
              </p>
              <p className="mb-1">
                <strong>Origem:</strong> {detalhe.metodo_http ? `${detalhe.metodo_http} ` : ""}
                {detalhe.origem || "—"}
              </p>
              {detalhe.codigo_erro && (
                <p className="mb-1">
                  <strong>Código:</strong> {detalhe.codigo_erro}
                </p>
              )}
              <Form.Group className="mb-2">
                <Form.Label className="small">Descrição</Form.Label>
                <Form.Control as="textarea" rows={4} readOnly value={detalhe.descricao || ""} />
              </Form.Group>
              {detalhe.contexto_json && (
                <Form.Group>
                  <Form.Label className="small">Contexto (JSON)</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={8}
                    readOnly
                    value={
                      typeof detalhe.contexto_json === "string"
                        ? detalhe.contexto_json
                        : JSON.stringify(detalhe.contexto_json, null, 2)
                    }
                  />
                </Form.Group>
              )}
            </>
          ) : null}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default LogsGodMode;
